module.exports = __webpack_public_path__ + "img/pulsa_icon.e9ed102b.svg";